/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.

/*
 * EXPORTS
 */
export default gql`
  mutation RestartRemoterServerMutation {
    RestartRemoterServer {
      details
      message
      status
      success
    }
  }
`
